import { DirectionEnum, SizeEnum } from './config';

export default {
  name: 'FcSteps',
  extends: 'Steps',
  props: {
    current: {
      type: Number,
      default: () => {
        return 0;
      },
    },
    size: {
      type: String,
      validator(value) {
        return Object.values(SizeEnum).includes(value);
      },
      default: () => {
        return SizeEnum.DEFAULT;
      },
    },
    direction: {
      type: String,
      validator(value) {
        return Object.values(DirectionEnum).includes(value);
      },
      default: () => {
        return DirectionEnum.HORIZONTAL;
      },
    },
    showLine: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    dataSource: {
      type: Array,
      default: () => {
        return [];
      },
    },
    className: {
      type: String,
      default: () => {
        return '';
      },
    },
    progressDot: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {},
  render() {
    const { _props, $listeners, $scopedSlots } = this;
    const { dataSource, direction } = _props;
    return (
      <div class={`${_props.className} ${_props.showLine ? '' : 'not-line'} fc-steps`}>
        <a-steps {...{ props: _props }} {...{ on: $listeners }} {...{ scopedSlots: $scopedSlots }}>
          {dataSource.map(item => {
            return (
              <a-step style={direction === 'vertical' ? { height: item.height + 'px' } : null}>
                <span slot="title"> {item.title} </span>
                <span slot="description">{item.description}</span>
              </a-step>
            );
          })}
        </a-steps>
      </div>
    );
  },
};
